import React, { useState } from "react";
import SaveButton from "../../../components/Buttons/SaveButton";
import SelectListField from "../../../components/Fields/SelectListField";
import { FormConfig } from "../../../components/Fields/Types";
import useSelectListOptions from "../../../components/Hooks/SelectListOptionsHook/useSelectListOptions";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import DataService from "../../../services/data.service";
import { BusinessPartnerPopupProps } from "../../../types/PopupProps";
import { DataResult } from "../../../types/Result";

interface BusinessPartnerEmployeeModel {
    businessPartnerId: number
    employeeId: number
    functionalRoleId: number
}

const AddBusinessPartnerEmployeePopup: React.FC<BusinessPartnerPopupProps> = ({ show, onHide, businessPartnerId, businessPartnerTypeId }) => {
    const [serverErrors, setServerErrors] = useState<DataResult<BusinessPartnerEmployeeModel>>({ isSuccesful: true, messages: [], data: undefined });
    const { handleResult, handleException } = useNotifications();

    const [formData, setFormData] = useState<BusinessPartnerEmployeeModel>({
        businessPartnerId: businessPartnerId,
        employeeId: 0,
        functionalRoleId: 0
    });

    const functionalRoles = useSelectListOptions('api/v1/selectlist/FunctionalRoles?businessPartnerTypeId=' + businessPartnerTypeId, '-- Select workflow role');
    const employees = useSelectListOptions('api/v1/selectlist/EmployeesForFunctionalRole?functionalRoleId=' + formData.functionalRoleId, '-- Select employee');

    function submit() {
        if (formData) {
            DataService
                .create<BusinessPartnerEmployeeModel>(`api/v1/BusinessPartnerEmployees`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true) {
                        if (onHide)
                            onHide();
                    }
                })
                .catch(e => handleException(e));
        }
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'employeeId', label: 'Employee', labelSize: 2, validationRules: [{ type: 'isRequired' }] },
            { name: 'functionalRoleId', label: 'Workflow role', labelSize: 2, validationRules: [{ type: 'isRequired' }] },
        ],
        handleSubmit: submit,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'Add Employee'} >
            <Popup.Body>
                <SelectListField {...getFieldProps('functionalRoleId')} options={functionalRoles} />
                <SelectListField {...getFieldProps('employeeId')} options={employees} />
            </Popup.Body>
            <Popup.Footer>
                <SaveButton text='Add' {...getSubmitButtonProps()} />
            </Popup.Footer>
        </Popup>
    );
}
export default AddBusinessPartnerEmployeePopup;